import React from "react";
import PrettyDate from "./PrettyDate";
import {tdStyles} from "./tableStyles";
import Direction from "./Direction";
import {validityPeriodToDisplay, valueOrEmDash} from "../../common/displayUtils";

const ChangeHistoryRow = (props) => (
    <tr>
        <td style={Object.assign({}, tdStyles, {width: "100px"})}><PrettyDate date={props.disseminatedOn} /></td>
        <td style={tdStyles}><Direction direction={props.direction} derivativeDescription={props.derivativeDescription}/></td>
        <td style={tdStyles}>{valueOrEmDash(props.targetPrice)}</td>
        <td style={tdStyles}>{valueOrEmDash(validityPeriodToDisplay(props.validityPeriod))}</td>
    </tr>
);
ChangeHistoryRow.propTypes = {
    disseminatedOn: React.PropTypes.string,
    direction: React.PropTypes.string,
    derivativeDescription: React.PropTypes.string,
    targetPrice: React.PropTypes.string,
    validityPeriod: React.PropTypes.string
};

export default ChangeHistoryRow;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/ChangeHistoryRow.js
 **/